import { render, staticRenderFns } from "./IntegralConfirm.vue?vue&type=template&id=be086cf0&scoped=true&"
import script from "./IntegralConfirm.vue?vue&type=script&lang=js&"
export * from "./IntegralConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be086cf0",
  null
  
)

export default component.exports